export default __webpack_public_path__ + "static/media/ag-img.834633e9.webp";